import {
  AUTH_LOGIN,
  AUTH_LOGOUT, CHANGE_USER_WORK_STATUS,
  CREATE_USER, DELETE_USER,
  EDIT_BALANCE, EDIT_SUPPORT_LIMIT,
  EDIT_USER,
  LOAD_USERS_LIST, RESET_SUPPORT_LIMIT,
} from './user';
import {
  LOAD_SETTINGS, LOAD_EXCHANGE_INFO,
  UPDATE_SETTING, LOAD_STATS, LOAD_ACTIONS_STATS
} from "./settings";
import {
  CANCEL_CLAIM, CANCEL_ORDER,
  EDIT_ORDER,
  FINISH_ORDER,
  LOAD_ORDERS_LIST,
  OPEN_CLAIM, REFINISH_ORDER, RESTART_FINISH_ERROR_ORDERS, SWITCH_NOTE,
} from './orders';
import { LOAD_CLAIMS } from "./claims";
import {
  ADD_TEMPLATE, CHAT_SEARCH,
  CHAT_SEND_MESSAGE, CLOSE_TICKET,
  DELETE_TEMPLATE,
  EDIT_TEMPLATE,
  LOAD_CHAT,
  LOAD_CHATS_LIST,
  LOAD_TEMPLATES
} from "./chats";
import {
  ADD_BLACK_LIST_REQUISITE,
  ADD_BLACK_LIST_USER, DELETE_BLACK_LIST_REQUISITE,
  DELETE_BLACK_LIST_USER, LOAD_EXCHANGE_SETTINGS,
  LOAD_BLACK_LIST_REQUISITES,
  LOAD_BLACK_LIST_USERS, EDIT_EXCHANGE_SETTINGS, ADD_USER_NOTE, DELETE_USER_NOTE,
} from './exchange';


const path = {
  [AUTH_LOGIN]: 'api/users/login',
  [AUTH_LOGOUT]: 'api/users/logout',
  [LOAD_USERS_LIST]: 'api/users',
  [CREATE_USER]: 'api/users',
  [EDIT_USER]: 'api/users',
  [EDIT_BALANCE]: 'api/users/balance',
  [EDIT_SUPPORT_LIMIT]: 'api/users/limit/edit',
  [RESET_SUPPORT_LIMIT]: 'api/users/limit/reset',
  [DELETE_USER]: 'api/users',
  [LOAD_ORDERS_LIST]: 'api/orders',
  [EDIT_ORDER]: 'api/orders/:id:',
  [FINISH_ORDER]: 'api/orders/:id:/finish',
  [REFINISH_ORDER]: 'api/orders/:id:/refinish',
  [CANCEL_ORDER]: 'api/orders/:id:/cancel',
  [LOAD_SETTINGS]: 'api/settings/global',
  [LOAD_EXCHANGE_SETTINGS]: 'api/exchange/settings',
  [EDIT_EXCHANGE_SETTINGS]: 'api/exchange/settings',
  [UPDATE_SETTING]: 'api/settings/global',
  [OPEN_CLAIM]: 'api/claims/:id:/claim',
  [CANCEL_CLAIM]: 'api/claims/:id:/claim',
  [LOAD_CLAIMS]: 'api/claims/:category:',
  [CHANGE_USER_WORK_STATUS]: 'api/users/settings/work_status/:status:',
  [LOAD_EXCHANGE_INFO]: 'api/exchange/info',
  [LOAD_CHATS_LIST]: 'api/chats',
  [LOAD_CHAT]: 'api/chats/:id:',
  [CHAT_SEND_MESSAGE]: 'api/chats/:id:/send',
  [LOAD_TEMPLATES]: 'api/chats/settings/templates',
  [ADD_TEMPLATE]: 'api/chats/settings/templates',
  [EDIT_TEMPLATE]: 'api/chats/settings/templates/:id:',
  [DELETE_TEMPLATE]: 'api/chats/settings/templates/:id:',
  [CHAT_SEARCH]: 'api/chats/search/:mode:',
  [CLOSE_TICKET]: 'api/chats/:id:/close',
  [LOAD_STATS]: 'api/orders/stats',
  [LOAD_ACTIONS_STATS]: 'api/users/actions',
  [LOAD_BLACK_LIST_USERS]: 'api/blacklist/users',
  [ADD_BLACK_LIST_USER]: 'api/blacklist/users',
  [DELETE_BLACK_LIST_USER]: 'api/blacklist/users',
  [LOAD_BLACK_LIST_REQUISITES]: 'api/blacklist/requisites',
  [ADD_BLACK_LIST_REQUISITE]: 'api/blacklist/requisites',
  [DELETE_BLACK_LIST_REQUISITE]: 'api/blacklist/requisites',
  [SWITCH_NOTE]: 'api/orders/:id:/notes/:type:',
  [RESTART_FINISH_ERROR_ORDERS]: 'api/service/orders/restart-finish-error',
  [ADD_USER_NOTE]: 'api/notes/users',
  [DELETE_USER_NOTE]: 'api/notes/users',
};
export default path;
